import React, { ReactElement } from 'react';

import { IRecommendationSettings } from 'types/recommendations.types';
import { Modal } from 'antd';
import { RecommendationsForm } from 'pages/Recommendations/components/RecommendationsForm';

type SettingsRecommendationModalProps<T> = {
  onHide: () => void;
  initialValues?: object;
  children?: ReactElement | ReactElement[];
  onSubmit: (values: T) => Promise<any>;
};

export const EditRecommendationModal = <T extends IRecommendationSettings>({
  children,
  onHide,
  initialValues,
  onSubmit,
}: SettingsRecommendationModalProps<T>) => (
  <Modal centered open={true} onCancel={onHide} footer={[]}>
    <RecommendationsForm<T>
      initialValues={initialValues}
      citiesDisabled={false}
      // onSubmit={onSubmit}
      onSubmit={async (values) => {
        // const items = initialValues?.items
        //   ? initialValues?.items.filter((el: any) => values.cityIds.includes(el.city.id))
        //   : [];
        // const data = { ...values, items };
        onSubmit({ ...values });
      }}
      btnText="Сохранить"
    >
      {children}
    </RecommendationsForm>
  </Modal>
);
